import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function AppCard({ app, index }) {
  return (
    <Link
      to={`/uygulama/${app.slug}`}
      data-testid={`app-card-${app.slug}`}
      className="group relative flex flex-col h-full bg-white border border-brand-line hover:border-brand-accent/35 shadow-[0_1px_2px_rgba(12,19,34,0.03)] hover:shadow-[0_28px_50px_-28px_rgba(15,56,122,0.35)] transition-[box-shadow,border-color,transform] duration-500 hover:-translate-y-1"
    >
      <div className="frame relative aspect-[16/10] overflow-hidden">
        <img
          src={app.image}
          alt={app.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-[1.07]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/75 via-brand-ink/10 to-transparent" />
        {typeof index === "number" && (
          <span className="absolute bottom-4 left-5 font-mono text-[10px] uppercase tracking-[0.22em] text-white/90">
            {String(index + 1).padStart(2, "0")} <span className="text-white/45">//</span> EN 1090-2
          </span>
        )}
      </div>
      <div className="p-7 flex flex-col flex-1">
        <h3 className="font-display text-[17px] font-medium tracking-[-0.02em] text-brand-ink group-hover:text-brand-accent transition-colors duration-300">
          {app.title}
        </h3>
        <p className="mt-3 text-[13.5px] text-brand-muted leading-relaxed font-light line-clamp-2 flex-1">{app.excerpt}</p>
        <div className="mt-6 pt-5 border-t border-brand-line-soft flex items-center justify-between">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-accent">Detay</span>
          <span className="w-8 h-8 rounded-full border border-brand-line group-hover:bg-brand-accent group-hover:border-brand-accent flex items-center justify-center transition-[background-color,border-color,transform] duration-300 group-hover:rotate-45">
            <ArrowUpRight className="w-3.5 h-3.5 text-brand-accent group-hover:text-white transition-colors duration-300" />
          </span>
        </div>
      </div>
    </Link>
  );
}
